<template>
  <div class="ang-card ang-card">
    <div class="ang-card-body">
      <div class="row">
        <div class="col-12">
          <div class="pb-4 m-0 text-center">
            <p class="h6 mb-4">
              <strong>Droga klientko, drogi kliencie!</strong>
            </p>
            Dbamy o bezpieczeństwo Twoich danych dlatego dostep do formularza
            został zabezpieczony. <br />
            Na Twój numer telefon wyślemy kod, który pozwoli odblokować Twoje
            dane.
          </div>
          <div
            role="alert"
            class="alert alert-warning ang-alert-warning mb-3"
            v-if="error"
          >
            <h5 class="ang-card-title">Uwaga!</h5>
            <ul>
              <li>
                Wiadomość SMS z kodem wysyłamy na Twój numer telefonu, który
                znajduje się w naszej bazie danych
              </li>
              <li>
                Twój kod bedzie ważny przez
                <span style="font-weight: 700">24 godziny</span> od momentu
                wygenerowania
              </li>
              <li>
                Jeżeli w ciągu 5 minut od wygenerowania kodu nie otrzymasz
                wiadomości SMS - skontaktuj się ze swoim ekspertem lub napisz na
                klient@angfinanse.pl
              </li>
              <li>Możesz wygenerować maksymalnie dwa kody na godzinę</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="form-group text-center">
        <div class="mb-4">
          <spinner v-if="sendingSMS" position="center"></spinner>
          <button
            v-else
            class="btn btn-lg ang-btn-lg ang-button _bg_color1"
            @click.stop.prevent="sendSMS(base)"
          >
            Wyślij SMS z kodem teraz
          </button>
        </div>
        <label class="text-center" for="code"
          >Podaj kod otrzymany w wiadomości SMS</label
        >
        <input
          type="text"
          class="ang-form-control"
          id="code"
          name="code"
          style="max-width: 200px; margin: 0 auto"
          required
          v-model="code"
        />
        <div class="text-success mt-2" v-if="smsSent">Kod został wysłany</div>
      </div>
      <div v-if="error && error.length > 0" class="text-center">
        <label class="error">{{ error }}</label>
      </div>
      <div class="text-center mt-4">
        <div>
          <spinner v-if="sendingLock" position="center"></spinner>
          <button
            v-else
            class="btn btn-lg ang-btn-lg ang-button"
            v-show="code && code.length > 0"
            @click.stop.prevent="getClientData(base)"
          >
            Potwierdź
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";
import spinner from "@/components/partials/misc/spinner";
import moment from "moment";

export default {
  data() {
    return {
      sendingLock: false,
      sendingSMS: false,
      smsSent: false,
      code: null,
      error: "",
    };
  },
  components: {
    spinner,
  },
  props: ["base", "type", "url"],
  methods: {
    sendSMS(base) {
      let self = this;
      self.sendingSMS = true;
      self.smsSent = false;
      self.error = "";
      api.get(
        "/client/code/" + base,
        { type: this.type },
        function () {
          self.sendingSMS = false;
          self.smsSent = true;
        },
        function () {
          self.sendingSMS = false;
          self.error = "Wystąpił błąd. Spróbuj ponownie za chwilę.";
        }
      );
    },
    getClientData(base) {
      let self = this;
      self.error = "";
      self.smsSent = false;
      if (!this.code || this.code.length === 0) {
        return;
      }
      self.sendingLock = true;
      api.get(
        self.url + "/" + base,
        { code: this.code },
        function (data) {
          localStorage.setItem(base, self.code);
          localStorage.setItem(self.type, moment().format("YYYY-MM-DD"));
          self.sendingLock = false;
          self.$emit("clientVerified", data, self.code);
        },
        function (data) {
          localStorage.removeItem(base, self.code);
          localStorage.removeItem(self.type, moment().format("YYYY-MM-DD"));
          self.sendingLock = false;
          if (typeof data.message !== "undefined" && data.message.length > 0) {
            self.error = data.message;
          } else {
            self.error = "Wystąpił błąd. Spróbuj ponownie za chwilę.";
          }
        }
      );
    },
  },
};
</script>
